import React, { createContext, useCallback, useContext, useState } from 'react';

export const ToastContext = createContext(null);

let idCounter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info') => {
    const id = ++idCounter;
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 4000);
  }, []);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer toasts={toasts} onDismiss={dismiss} />
    </ToastContext.Provider>
  );
}

const TYPE_CLASS = {
  success: 'text-bg-success',
  error:   'text-bg-danger',
  warning: 'text-bg-warning',
  info:    'text-bg-info',
};

const TYPE_ICON = {
  success: '✅',
  error:   '❌',
  warning: '⚠️',
  info:    'ℹ️',
};

function ToastContainer({ toasts, onDismiss }) {
  if (toasts.length === 0) return null;
  return (
    <div
      style={{ position: 'fixed', bottom: '1.5rem', right: '1.5rem', zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
    >
      {toasts.map(t => (
        <div key={t.id} className={`toast show align-items-center ${TYPE_CLASS[t.type] || TYPE_CLASS.info}`} role="alert" aria-live="assertive">
          <div className="d-flex">
            <div className="toast-body d-flex align-items-center gap-2">
              <span>{TYPE_ICON[t.type] || TYPE_ICON.info}</span>
              <span>{t.message}</span>
            </div>
            <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => onDismiss(t.id)} aria-label="Close" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx;
}

export default ToastProvider;
